<ng-container *ngIf="dataLoaded">
    <div class="modal-body" *ngIf="nmvtisMessageModel?.nmvtisResponse">
        <h2>{{message}}</h2>
    </div>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" (click)="onSaveClick()">Continue</button>
        </div>
    </div>
</ng-container>